import { styled } from '@mui/material/styles'

import { Box } from '@mui/material'

interface CardGridProps {
  columns: number
}

export const CardGridWrapper = styled(Box)({
  backgroundColor: '#0d0d0d',
})

export const CardGrid = styled(Box)<CardGridProps>(({ columns }) => ({
  display: 'grid',
  gridTemplateColumns: `repeat(${columns}, 1fr)`,
  columnGap: '70px',
  margin: '0 auto',
  width: 'fit-content',
  paddingTop: '40px',
  paddingBottom: '40px',
  '@media (max-width: 1494px)': {
    columnGap: '20px',
  },
  '@media (max-width: 1408px)': {
    gridTemplateColumns: `repeat(${columns === 1 ? 1 : 2}, 1fr)`,
  },
  '@media (max-width: 1020px)': {
    gridTemplateColumns: `repeat(${columns === 1 ? 1 : 1}, 1fr)`,
  },
  '@media (max-width: 600px)': {
    width: '100%',
    paddingLeft: '16px',
    paddingRight: '16px',
    paddingTop: '20px',
    paddingBottom: '20px',
    columnGap: '12px',
    boxSizing: 'border-box',
  },
}))
